<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
       <a-button type="primary" ghost v-has:wxReplySynchro="()=>$router.push('/wxPublic/wxBase/index')" style="position: absolute;right:20px;z-index:100">同步微信内容</a-button>
      <a-tabs  type="card">
        <a-tab-pane key="1" tab="被添加自动回复">
          <addReply></addReply>
        </a-tab-pane>
        <a-tab-pane key="2" tab="消息自动回复">
          <msgReply></msgReply>
        </a-tab-pane>
        <a-tab-pane key="3" tab="关键词自动回复">
          <keyReply></keyReply>
        </a-tab-pane>
      </a-tabs>
    </a-card>
  </a-layout>
</template>
<script>
  import addReply from './components/add_reply';
  import msgReply from './components/msg_reply';
  import keyReply from './components/key_reply';
  export default {
    components: { addReply, msgReply, keyReply },
    setup(props) {
      return {
      };
    },
  };
</script>

<style lang="less" >
  .div{
    right: 0;
  }
</style>